import {makeStyles} from "@material-ui/core" 
import Amplify, {Storage} from "aws-amplify"
import React, {useState, useEffect, useRef} from "react"
import * as Tone from "tone"
import chapters from "../data/chapterText"
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import awsconfig from '../aws-exports' 

Amplify.configure(awsconfig)

const {chapterTxt, chapterStart, contributors, organizers} = chapters

let margin = "8px"
const fontSize = "14px"

let campfire = ""
+ '                 @               \n'
+ '                /                \n'            
+ '              &/@                \n'
+ '              @//@/@             \n'
+ '               /,(#@//           \n'
+ '             @&%/,@/,,/          \n'
+ '            (//,,@@.,( */        \n'
+ '          @@@,,,,.@@@,,,///@     \n'
+ '         @/@ /,,@@@@@.,,,,,/     \n'
+ '        &/,,,,@@@@@@@@,.,,,/@    \n'
+ '         /,,..@@@@@@@@..,,/      \n'
+ '           @,...@@@@@....,/@     \n'
+ '       ((**/***********((*(((%   \n'
+ '      **@%%@@((%@(((@%((%(@%@@*  \n'
+ '        %%.**@&,.@...,@@#(*%     \n'


let helpText = "-HELP-\n\nThe following are valid commands and their expected results.\n\n"
helpText += "---------------------------------------\n"  
helpText += "begin - starts story from beginning\n\n"  
helpText += "begin [chapter number] - starts story from given chapter number\n\n"
helpText += "stop - stop current story\n\n" 
helpText += "continue - continue from stop\n\n" 
helpText += "help - displays commands and their functions\n\n" 
helpText += "credits - displays credits\n\n"
helpText += "louder - raise volume\n\n"
helpText += "softer - lower volume\n\n"
helpText += "mute - mute audio\n\n"
helpText += "unmute - unmute audio\n"
helpText += "---------------------------------------"  

let titleText = campfire + "\n\n\n"
titleText += "CMPFR.22C <tales from the 22nd Century>\n\n"
titleText += "!WHAT WILL THE WORLD BE LIKE 100 YEARS FROM NOW? \n\n"
titleText += "CMPFR.22c is a collaborative storytelling project of speculative fiction, an episodic future history crossing genres and generations — stories told around the campfire where humans have gathered over thousands of years to share our experience, our wisdom, our hopes, and our fears.\n\n"
titleText += "CMPFR.22c brings together storytellers, actors, artists, and sound artists-designers around a “sonic campfire” to create a collection of stories imagining the decades of the 22nd century.\n\n"
titleText += "Click to the right of the arrow below, type begin and hit enter to get started. Click help to see available commands"

let creditsText = "Contributors\n"
creditsText += "---------------\n"

contributors.sort().forEach((contributor) => {
  creditsText += contributor + "\n"
})

creditsText += "\n\n"
creditsText += "Organizers\n"
creditsText += "---------------\n"
organizers.sort().forEach((organizer) => {
  creditsText += organizer + "\n"
})

creditsText += "\n\n"

creditsText += "Interactive web terminal made with <3 by James Wenlock"
creditsText += "\n\n"

creditsText += "REALMOREREAL"

const framerate = 10

const Terminal = () => {

  const convertTime = (seconds) => {
    const minutes = Math.floor(seconds / 60)
    seconds = seconds % 60
    seconds = Math.floor(seconds)
    if (seconds < 10) 
        seconds = "0" + seconds
    return ("" + minutes + ":" + seconds)
  }

  const [text, setText] = useState(titleText)
  const [timerText, setTimerText] = useState(convertTime(0))
  const [cmd, setCmd] = useState("")
  const [curPlayer, setCurPlayer] = useState(NaN)
  const [loadIndex, setLoadIndex] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [isStarted, setIsStarted] = useState(false)
  const [storyIndex, setStoryIndex] = useState(0)
  const clockIDRef = useRef(NaN)
  const loadingIDRef = useRef(NaN)
  const storyIndexRef = useRef(NaN)
  const playerRef = useRef(NaN)
  const curTime = useRef(0)

  useEffect(() => {
    storyIndexRef.current = storyIndex
    if (curTime.current > 0)
      setText(chapterTxt[storyIndex].txt)
  }, [storyIndex])

  useEffect(() => {
    playerRef.current = curPlayer
  }, [curPlayer])

  const loadStates = [".", "..", "..."]

  useEffect(() => {
    setText("loading" + loadStates[loadIndex])
  }, [loadIndex])

  const load = () => {
    setLoadIndex(prevIndex => (prevIndex + 1) % loadStates.length)
  }

  useEffect(() => {
    if (isLoading) {
      loadingIDRef.current = setInterval(load, 1000 / 2)
    } else {
      if (loadingIDRef.current) {
        clearInterval(loadingIDRef.current)
        loadingIDRef.current = NaN
      }
    }
  }, [isLoading])

  useEffect(() => {
    setIsLoading(true)
    Storage.get('cmpfr.mp3', {expires: 1000}).then(url => {
      const player = new Tone.Player(url, () => {
        setText(titleText)
        setIsLoading(false)
      }).toDestination()
      setCurPlayer(player)
    })
  }, [])

  // update time
  const tick = () => {
    if (storyIndexRef.current < chapterTxt.length - 1) {
      const {time} = chapterTxt[storyIndexRef.current + 1]
      if (curTime.current >= time) {
        setStoryIndex(prevIndex => prevIndex + 1)
      }
    } else {
      setStoryIndex(chapterTxt.length - 1)
    }
    setText(chapterTxt[storyIndexRef.current].txt)
    setTimerText(convertTime(curTime.current))
    // setTimerText(Math.floor(curTime.current * 100) / 100)
    curTime.current += (1 / framerate)
    if (curTime.current > 2560) {
      stop()
      credits()
    }
  }

  const startTimer = () => {
    clockIDRef.current = setInterval(tick, 1000 / framerate)
  }

  const stopTimer = () => {
    if (clockIDRef.current) {
      clearInterval(clockIDRef.current)
      clockIDRef.current = NaN
    }
  }

  const useStyle = makeStyles({
    flexWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100vw"
    },
    terminalDiv: {
      height: "60vh",
      width: "400px",
      borderStyle: "solid",
      borderRadius: 5,
      borderWidth: 0.5,
      position: "relative",
    },
    terminalText: {
      position: "absolute",
      display: "inline-block",
      wordBreak: "break-word",
      top: 0,
      height: "86%",
      width: "96%",
      marginLeft: margin,
      marginRight: margin,
      overflow : "scroll",
      fontSize: fontSize,
      whiteSpace: "pre-wrap"     
    },
    cmdContainer: {
      position: "absolute",
      bottom: "20px",
      marginLeft: margin,
      marginRight: margin,
      marginBottom: "10px",
      width: "93%",
      height: "20px",
      display: "flex",
      flexDirection: "row",
      alignContent: "center",
    },
    terminalIcon: {
      fontSize: fontSize,
      position: "relative",
      bottom: "13px"
    },
    terminalCmd: {
      resize: "none",
      background: "transparent",
      border: "0 none",
      fontSize: fontSize,
      marginLeft: "5px",
      width: "90%"
    },
    timerText: {
      position: "absolute",
      textAlign: "center",
      fontSize: fontSize,
      height: "20px",
      bottom: "0px",
      left: "0px",
      width: "100%"
    },
    help: {
      position: "absolute",
      fontSize: fontSize * 2,
      bottom: "14px",
      right: "10px",
      "&:hover": {
        cursor: "pointer"
      },
      zIndex: 10
    }
  })

  const classes = useStyle()

  const parseCmd = (cmd) => cmd.trim().split(" ")

  // show title
  const title = () => {
    setText(titleText)
    stop()
  }

  // starts story from beginning
  const begin = () => {
    curTime.current = 0
    setStoryIndex(0)
    setText(chapterTxt[0].txt)
    if (curPlayer && !(curPlayer.state === "started")) {
      curPlayer.start()
    } else {
      curPlayer.stop()
      curPlayer.start()
    }
    stopTimer()
    startTimer()
  }

  // starts story from given chapter number
  const beginFrom = (chapter) => {
    const thisChapterStart = chapterStart[chapter - 1]
    curTime.current = thisChapterStart
    let curTextIndex = 0;
    while (chapterTxt[curTextIndex] && thisChapterStart > chapterTxt[curTextIndex].time) {
      curTextIndex++
    }
    curTextIndex = curTextIndex - 1 < 0 ? curTextIndex: curTextIndex - 1 
    setStoryIndex(curTextIndex)
    if (curPlayer && !(curPlayer.state === "started")) {
      curPlayer.start(0, thisChapterStart)
    } else {
      curPlayer.stop()
      curPlayer.start(0, thisChapterStart)
    }
    stopTimer()
    startTimer()
  }

  // // starts story from given chapter number
  // const beginFrom = (chapter) => {
  //   chapter = parseFloat(chapter)
  //   curTime.current = chapter
  //   let curTextIndex = 0;
  //   while (chapterTxt[curTextIndex] && chapter > chapterTxt[curTextIndex].time) {
  //     curTextIndex++
  //   }
  //   curTextIndex = curTextIndex - 1 < 0 ? curTextIndex: curTextIndex - 1 
  //   setStoryIndex(curTextIndex)
  //   if (curPlayer && !(curPlayer.state === "started")) {
  //     curPlayer.start(0, chapter)
  //   } else {
  //     curPlayer.stop()
  //     curPlayer.start(0, chapter)
  //   }
  //   stopTimer()
  //   startTimer()
  // }

  // stops current story 
  const stop = () => {
    // setText("stopping story at " +  (Math.floor(curTime.current * 100) / 100))
    if (curPlayer && (curPlayer.state === "started")) {
      curPlayer.stop()
    }
    if (clockIDRef.current) {
      stopTimer()
    }
  }

  // continues from stop
  const continueStory = () => {
    setText(chapterTxt[storyIndex].txt)
    if (curPlayer && !(curPlayer.state === "started")) {
      curPlayer.start(0, curTime.current)
      startTimer()
    }
  }

  // message when command is invalid
  const cmdInvalid = () => {
    setText("Command invalid. Type help view available commands.")
    stop()
  }

  // sets text to help
  const help = () => {
    setText(helpText)
    stop()
  }

  const credits = () => {
    setText(creditsText)
    stop()
  }

  const louder = () => {
    if (curPlayer.volume.value < 0) {
      curPlayer.volume.linearRampTo(curPlayer.volume.value + 12, 0.01)
    }
  }

  const softer = () => {
    if (curPlayer.volume.value > -96) {
      curPlayer.volume.linearRampTo(curPlayer.volume.value - 12, 0.01)
    }
  }

  const mute = () => {
    curPlayer.mute = true
  }

  const unmute = () => {
    curPlayer.mute = false
  }

  const handleCmd = () => {
    let parsedCmd = cmd.toLowerCase()
    parsedCmd = parseCmd(parsedCmd)
    const isSingleCmd = parsedCmd.length === 1
    let chapter = isSingleCmd ? NaN : parseInt(parsedCmd[1])
    if (chapter < 1 || chapter > 10) {
      chapter = NaN
    } 
    switch (parsedCmd[0]) {
      case "title": 
        title()
        break;
      case "begin":
        if (isSingleCmd) {
          begin()
        } else if (chapter) {
          beginFrom(chapter)
        } else {
          cmdInvalid()
        }
        break;
      case "stop": 
        stop()
        break;
      case "continue": 
        continueStory()
        break;
      case "help": 
        help()
        break;
      case "credits": 
        credits()
        break;
      case "louder": 
        louder()
        break;
      case "softer": 
        softer()
        break;
      case "mute": 
        mute()
        break;
      case "unmute": 
        unmute()
        break;
      default:
        cmdInvalid()
        break;
    }
    setCmd("")
  }

  // handles input from command line
  const handleChange = (e) => {
    if (!isStarted) {
      Tone.start()
      setIsStarted(true)
    }
    const data = e.nativeEvent.data
    if (data) {
      setCmd(prevCmd => {
        return (prevCmd + data)
      })
    } else {
      if (e.nativeEvent.inputType === "insertLineBreak") {
        handleCmd()
      } else if (e.nativeEvent.inputType === "deleteContentBackward")
        setCmd(prevCmd => {
          if (prevCmd.length > 0) {
            return prevCmd.substr(0, (prevCmd.length - 1))
          } 
          return prevCmd
        }) 
    }
  }

  return (
    <div className={classes.flexWrapper}>
      <div className={classes.terminalDiv}>
        {!isLoading ? <HelpOutlineIcon 
          onClick={help}
          className={classes.help}
        /> : <> </>}
        <pre className={classes.terminalText}>  
          {text}
        </pre>
        {!isLoading ? <pre className={classes.timerText}>
          {timerText}
        </pre> : <> </>}
        {!isLoading ? <div className={classes.cmdContainer}>
          <p className={classes.terminalIcon}> {'>'} </p>
          <textarea 
            value={cmd} 
            onChange={handleChange} 
            className={classes.terminalCmd}
          > 
          </textarea>
        </div> : <></>}
      </div>
    </div>
  )
}

export default Terminal